import React, { Component } from 'react';
import { TextInput, Button, FormItem } from 'carbon-components-react';
import moment from 'moment';
import { StepCard, DatePicker, Notification } from '..';
import CancelModal from '../Modal/CancelModal';
import { nextDayAvailable, excludedDatesForCampaing, datesArrayToString } from '../../utils';

class SendDate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentDate:
        props.singleDate && props.dates.length ? props.dates[0].dataEnvio : nextDayAvailable,
      dates: props.dates.length ? props.dates.map(obj => obj.dataEnvioFormatada) : [],
      cancelModal: false,
      isEdited: false,
    };
  }

  onDateChange = date => {
    this.setState({ currentDate: date });
  };

  addDate = () => {
    const { currentDate } = this.state;

    this.setState(prevState => ({
      dates: [...prevState.dates, moment(currentDate).format('DD/MM/YYYY')],
      isEdited: true,
    }));
  };

  removeDate = index => {
    this.setState(prevState => {
      const newDates = [...prevState.dates];
      newDates.splice(index, 1);
      return { dates: newDates, isEdited: true };
    });
  };

  toggleCancelModal = () => {
    this.setState(prevState => ({ cancelModal: !prevState.cancelModal }));
  };

  save = async () => {
    const { currentDate, dates } = this.state;
    const { singleDate, saveStep } = this.props;

    if (singleDate) {
      dates[0] = moment(currentDate).format('DD/MM/YYYY');
    }
    const dados = {
      arrDatasEnvio: [...dates],
      currentDate: moment(currentDate).toISOString(),
      salvouDatasEnvios: true,
    };
    
    const data = await saveStep(dados);
    console.log(data)
    this.stepCardRef.toggleContent();
  };

  requestCancel = () => {
    const { isEdited } = this.state;

    if (isEdited) {
      this.toggleCancelModal();
    } else {
      this.cancel();
    }
  };

  cancel = () => {
    const { dates } = this.props;

    this.setState({
      dates: dates.length ? dates.map(obj => obj.dataEnvioFormatada) : [],
      currentDate: nextDayAvailable,
      isEdited: false,
      cancelModal: false,
    });
    this.stepCardRef.toggleContent();
  };

  renderDatesList = () => {
    const { singleDate } = this.props;
    const { dates } = this.state;

    if (!dates.length) return null;

    if (singleDate) {
      dates.splice(0, 1);
    }

    return dates.map((date, index) => (
      <div key={date} className="bx--row">
        <div className="bx--col-xs-12 bx--col-sm-5 bx--col-inline v-sm-margin">
          <TextInput id={`date-${index}`} labelText="" value={date} disabled />

          {!singleDate && (
            <button
              kind="ghost"
              type="submit"
              className="button button--clear button--icon danger h-sm-margin"
              onClick={() => this.removeDate(index)}
            >
              <i className="material-icons">delete_outline</i>
            </button>
          )}
        </div>
      </div>
    ));
  };

  renderDescription = () => {
    const { step, dates } = this.props;

    if (dates.length) {
      const datesArr = dates.map(obj => obj.dataEnvioFormatada);

      return (
        <div className="font-size-13" style={{ color: '#36474f' }}>
          <div dangerouslySetInnerHTML={{ __html: datesArrayToString(datesArr) }} />
        </div>
      );
    }

    return step.description;
  };

  render() {
    const { currentDate, dates, cancelModal } = this.state;
    const { step, campaignItem, singleDate, disabled, showSave } = this.props;
    const isFinished = campaignItem && campaignItem.salvouDatasEnvios;
    const userData = JSON.parse(localStorage.getItem("user"));    
    const isAdmin = userData.nivel.id === 10 && userData.comunicacao === true;
  
    return (
      <StepCard
        onRef={ref => {
          this.stepCardRef = ref;
        }}
        title={step.title}
        description={this.renderDescription()}
        isFinished={isFinished}
        disabled={disabled}
      >
        <div className="bx--grid">
          {campaignItem &&
            campaignItem.outroCriterio && (
              <div className="bx--row">
                <Notification
                  kind="warning"
                  title="Atenção"
                  description="Devido ao filtro Outros Critérios, o prazo para envio poderá variar."
                />
              </div>
            )}
          <div className="bx--row">
            <div className="bx--col-xs-12 bx--col-sm-5 bx--col-inline">
              {isAdmin ? (
                <FormItem>
                  <DatePicker
                    date={currentDate ? moment(currentDate) : ""}
                    onDateChange={this.onDateChange}
                    locale="pt"
                    isOutsideRange={() => false}
                    small={false}
                  />
                </FormItem>
              ) : (
                <FormItem>
                  <DatePicker
                    date={currentDate ? moment(currentDate) : ""}
                    onDateChange={this.onDateChange}
                    locale="pt"
                    isDayBlocked={excludedDatesForCampaing}
                    small={false}
                  />
                </FormItem>
                )}

              {!singleDate && (
                <button
                  kind="ghost"
                  className="button button--clear button--icon h-sm-margin"
                  onClick={() => this.addDate()}
                  type="submit"
                >
                  <i className="material-icons">add_circle</i>
                </button>
              )}
            </div>
          </div>
          {this.renderDatesList()}
          {showSave && (
            <div className="bx--row">
              <div className="bx--col-xs-12 bx--col-sm-6 v-md-margin">
                <Button disabled={singleDate ? !currentDate : !dates.length} onClick={this.save}>
                  Salvar
                </Button>
                <Button kind="ghost" className="h-sm-margin" onClick={this.requestCancel}>
                  Cancelar
                </Button>
              </div>
            </div>
          )}
          <CancelModal open={cancelModal} onOk={this.cancel} onCancel={this.toggleCancelModal} />
        </div>
      </StepCard>
    );
  }
}

export default SendDate;



// WEBPACK FOOTER //
// ./src/components/campaigns/SendDate.js